import { URL_CONST } from 'utils/urlConsts'

export const GROUP_SETTINGS_MENU_ITEMS = [
  {
    name: 'Company Settings',
    icon: 'single_neutral_actions_setting_users_18_1',
    url: URL_CONST.settings.general,
  },
  {
    name: 'Group Settings',
    icon: 'Group-settings',
    url: URL_CONST.groupSettings.self,
  },
]
